<template>
    <!-- Hero Section -->
	<section class="hero-section" id="home">
		<div class="hero-content position-relative overflow-hidden">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6">
						<div class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".25s">
							<h1 class="mb-2">Connect with Nearby Top-rated Professional <span class="typed" data-type-text="Carpenters">Carpenters</span></h1>
							<p class="mb-3 sub-title">We can connect you to the right Service, first time and every
								time.</p>
							<div class="banner-form bg-white border mb-3">
								<form action="#">
									<div class="d-md-flex align-items-center">
										<div class="input-group mb-2">
											<span class="input-group-text px-1"><i class="ti ti-search"></i></span>
											<input type="text" class="form-control" placeholder="Search for Service">
										</div>
										<div class="input-group mb-2">
											<span class="input-group-text px-1"><i class="ti ti-map-pin"></i></span>
											<input type="text" class="form-control" placeholder="Enter Location">
										</div>
										<div class="mb-2">
											<router-link to="/service/search" class="btn btn-linear-primary d-inline-flex align-items-center w-100">
												<i class="feather-search me-2"></i>
												Search
											</router-link>
										</div>
									</div>
								</form>
								<img src="@/assets/img/bg/bg-06.svg" alt="img" class="shape-06 round-animate">
							</div>
							<div class="d-flex align-items-center flex-wrap">
								<h6 class="mb-2 me-2 fw-medium">Popular Searches</h6>
								<router-link to="/service/search"
									class="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2">Plumber</router-link>
								<router-link to="/service/search"
									class="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2">Interior</router-link>
								<router-link to="/service/search"
									class="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2">Nail Technicians</router-link>
							</div>
							<div class="d-flex align-items-center flex-wrap banner-info">
								<div class="d-flex align-items-center me-4 mt-4">
									<img src="@/assets/img/icons/success-01.svg" alt="icon">
									<div class="ms-2">
										<h6>215,292 +</h6>
										<p>Verified Providers</p>
									</div>
								</div>
								<div class="d-flex align-items-center me-4 mt-4">
									<img src="@/assets/img/icons/success-02.svg" alt="icon">
									<div class="ms-2">
										<h6>90,000+</h6>
										<p>Services Completed</p>
									</div>
								</div>
								<div class="d-flex align-items-center me-4 mt-4">
									<img src="@/assets/img/icons/success-03.svg" alt="icon">
									<div class="ms-2">
										<h6>2,390,968 </h6>
										<p>Reviews Globally</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="banner-img wow fadeInUp" data-wow-duration="1s" data-wow-delay=".25s">
						<img src="@/assets/img/banner.png" alt="img" class="img-fluid animation-float">
					</div>
				</div>
			</div>
			<div class="hero-image">
				<div class="d-inline-flex bg-white p-2 rounded align-items-center shape-01 floating-x">
					<span class="avatar avatar-md bg-warning rounded-circle me-2"><i class="ti ti-star-filled"></i></span>
					<span>4.9 / 5<small class="d-block">(255 reviews)</small></span>
					<i class="border-edge"></i>
				</div>
				<div class="d-inline-flex bg-white p-2 rounded align-items-center shape-02 floating-x">
					<span class="me-2"><img src="@/assets/img/icons/tick-banner.svg" alt=""></span>
					<p class="fs-12 text-dark mb-0">300 Booking Completed</p>
					<i class="border-edge"></i>
				</div>
				<img src="@/assets/img/bg/bg-03.svg" alt="img" class="shape-03">
				<img src="@/assets/img/bg/bg-04.svg" alt="img" class="shape-04">
				<img src="@/assets/img/bg/bg-05.svg" alt="img" class="shape-05">
			</div>
		</div>
	</section>
	<!-- /Hero Section -->

     <!-- Category Section -->
	<section class="section category-section">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
					<div class="section-header text-center">
						<h2 class="mb-1">Explore our <span class="text-linear-primary">Categories</span></h2>
						<p class="sub-title">Service categories help organize and structure the offerings on a
							marketplace, making it easier for users to find what they need.</p>
					</div>
				</div>
			</div>
			<div
				class="row g-4 row-cols-xxl-6 row-cols-xl-6 row-cols-md-4 row-cols-sm-2 row-cols-1 justify-content-center">
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-01.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Construction</h6>
						<p class="fs-14 mb-0">9874 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-02.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Removals</h6>
						<p class="fs-14 mb-0">787 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-13.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Cleaning</h6>
						<p class="fs-14 mb-0">2357 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-04.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Computer Service</h6>
						<p class="fs-14 mb-0">1260 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-05.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Electrical</h6>
						<p class="fs-14 mb-0">4546 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-06.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Man & Van</h6>
						<p class="fs-14 mb-0">2546 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-07.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Deliveries</h6>
						<p class="fs-14 mb-0">4547 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-08.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Mobile Barber</h6>
						<p class="fs-14 mb-0">4787 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
						<span class="badge bg-success">New</span>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-09.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Interior</h6>
						<p class="fs-14 mb-0">1457 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-10.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Plumbing</h6>
						<p class="fs-14 mb-0">4157 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-11.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Nail Technicians</h6>
						<p class="fs-14 mb-0">5477 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
				<div class="col-lg-2 d-flex">
					<div class="category-item text-center flex-fill wow fadeInUp" data-wow-delay="0.2s">
						<div class="mx-auto mb-3">
							<img src="@/assets/img/icons/category-12.svg" class="img-fluid" alt="img">
						</div>
						<h6 class="fs-14 mb-1">Hair Dressers</h6>
						<p class="fs-14 mb-0">7457 Listings</p>
						<router-link to="/service-categories/categories" class="link-primary text-decoration-underline fs-14">View All</router-link>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="text-center view-all wow fadeInUp" data-wow-delay="0.2s">
						<router-link to="/service-categories/categories" class="btn btn-dark">View All<i
								class="ti ti-arrow-right ms-2"></i></router-link>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /Category Section -->
</template>